import { IResponse } from "models";

export enum ActionType {
  DOWNLOAD_CONSULTATION_CSV = "action/DOWNLOAD_CONSULTATION_CSV",
  DOWNLOAD_CONSULTATION_CSV_SUCCESS = "action/DOWNLOAD_CONSULTATION_CSV_SUCCESS",
  DOWNLOAD_CONSULTATION_CSV_ERROR = "action/DOWNLOAD_CONSULTATION_CSV_ERROR",
  DOWNLOAD_CONSULTATION_CSV_RESET = "action/DOWNLOAD_CONSULTATION_CSV_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface DownloadConsultationCSVPayload {
  to_date: string;
  from_date: string;
}

export interface IDoctorResponse {
  comment: string;
  diagnosis_comment: string;
  diagnosis_title: string;
  end_greeting: string;
  medical_instruction_comment: string;
  medical_instruction_title: string;
  medicine_comment: string;
  medicines_count_positive: any;
  medicines_name: string;
  start_greeting: string;
  hospital_names: string;
}

export interface IConsultCSVData {
  id: number;
  consultation_created_at: string;
  disease_name: string;
  doctor_name: string;
  doctor_response_created_at: string;
  doctor_response: IDoctorResponse;
  patient: {
    age: number | null;
    gender: number;
  };
  is_cancel?: boolean;
  is_free?: boolean;
}

export interface IConsultationCSVResponse extends IResponse {
  result: IConsultCSVData[];
  total_record: number;
}
